/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isJSFunction(x) {
  return typeof x === 'object' && x && x.type === 'JSFunction';
}